module.exports = __webpack_public_path__ + "img/oscar-logo.1b7c18f9.svg";